// Module
var code = "<input class=\"datePicker\" data-test-id=\"datepicker\" placeholder=\"Date\" type=\"text\"/> ";
// Exports
export default code;